"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterFollow1Schema = void 0;
exports.TwitterFollow1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/twitter-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TwitterFollow1",
    "description": "Add a twitter follow button",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:twitter-sociallink:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "twitterUser": {
                    "type": "string",
                    "description": "e.g. '@redbull'"
                }
            },
            "required": [
                "twitterUser"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90d2l0dGVyLXNvY2lhbGxpbmsvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxvQkFBb0IsR0FBRztJQUNsQyxLQUFLLEVBQUUsdUZBQXVGO0lBQzlGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGdCQUFnQjtJQUN6QixhQUFhLEVBQUUsNkJBQTZCO0lBQzVDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiwrQ0FBK0M7YUFDaEQ7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxpQkFBaUI7aUJBQ2pDO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsYUFBYTthQUNkO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=